

import React from 'react'

export const LogementContext = React.createContext([]);

export const DetailLogementContext = React.createContext("");

export const ArticlesContext = React.createContext([]);
export const ArticleContext = React.createContext("");